import { combineReducers } from 'redux';
import { LOCATION_CHANGE } from 'react-router-redux/reducer';
import { SHOW_SUB_NAV, HIDE_SUB_NAV } from './constants';

const subNav = (state = null, action) => {
    switch (action.type) {
        case SHOW_SUB_NAV:
            return action.subNav;
        case LOCATION_CHANGE:
        case HIDE_SUB_NAV:
            return null;
        default:
            return state;
    }
};

export default combineReducers({
    subNav
});



// WEBPACK FOOTER //
// ./src/services/nav/reducer.js